document.addEventListener('change', function(e) {
  // ¿Cambió un radio de variante?
  if (e.target && e.target.matches('.opt-btn[type="radio"]')) {
    // Busca el label asociado al radio seleccionado
    var label = document.querySelector('label[for="' + e.target.id + '"]');
    if (label) {
      // Busca el badge dentro de ese label
      var badge = label.querySelector('.discount-badge');
      if (badge) {
        // Reinicia solo ese badge
        badge.classList.remove('discount-badge');
        void badge.offsetWidth;
        badge.classList.add('discount-badge');
      }
    }
  }
});
